export default __webpack_public_path__ + "static/media/News & Announcements.9b62b29c.svg";